import { render, staticRenderFns } from "./PropertyViewHeader.vue?vue&type=template&id=6c71c027&scoped=true"
import script from "./PropertyViewHeader.vue?vue&type=script&lang=js"
export * from "./PropertyViewHeader.vue?vue&type=script&lang=js"
import style0 from "./PropertyViewHeader.vue?vue&type=style&index=0&id=6c71c027&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71c027",
  null
  
)

export default component.exports